import { render, staticRenderFns } from "./InvocationsPanel.vue?vue&type=template&id=08d6aec5"
import script from "./InvocationsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvocationsPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports